import type { AudioLanguage } from "@/utils/types";

export type CartesiaLanguage =
  | "en"
  | "hi"
  | "es"
  | "de"
  | "ar"
  | "ko"
  | "fr"
  | "ja"
  | "ta"
  | "te"
  | "pt"
  | "it"
  | "pl"
  | "ru"
  | "zh"
  | "tr"
  | "sv"
  | "nl"
  | "vi"
  | "ml"
  | "he"
  | "da"
  | "no"
  | "kn"
  | "fi"
  | "mr"
  | "bn"
  | "sk"
  | "uk"
  | "el"
  | "id"
  | "ro"
  | "ka"
  | "ms"
  | "bg"
  | "th"
  | "hu"
  | "pa"
  | "cs"
  | "tl"
  | "gu"
  | "hr";

export const AUDIO_LANGUGAGE_TO_CARTESIA_LANGUAGE: Record<
  AudioLanguage,
  CartesiaLanguage | null
> = {
  // Directly supported languages
  en: "en",
  "en-medical": "en",
  fr: "fr",
  "fr-CA": "fr",
  de: "de",
  "de-CH": "de",
  it: "it",
  pt: "pt",
  "pt-BR": "pt",
  es: "es",
  zh: "zh",
  "zh-TW": "zh",
  ar: "ar",
  bn: "bn",
  bg: "bg",
  hr: "hr",
  cs: "cs",
  da: "da",
  nl: "nl",
  "nl-BE": "nl", // Flemish is Dutch
  fi: "fi",
  ka: "ka",
  el: "el",
  gu: "gu",
  he: "he",
  hi: "hi",
  hu: "hu",
  id: "id",
  ja: "ja",
  ko: "ko",
  ms: "ms",
  mr: "mr",
  no: "no",
  pl: "pl",
  ro: "ro",
  ru: "ru",
  sk: "sk",
  sv: "sv",
  tl: "tl",
  ta: "ta",
  te: "te",
  th: "th",
  tr: "tr",
  uk: "uk",
  vi: "vi",
  kn: "kn",
  ml: "ml",
  pa: "pa",

  // No close match
  ur: null,
  bs: null,
  sr: null,
  gl: null,
  mk: null,
  be: null,
  af: null,
  sq: null,
  am: null,
  hy: null,
  as: null,
  az: null,
  ba: null,
  eu: null,
  br: null,
  "zh-HK": null,
  ca: null,
  et: null,
  fo: null,
  ht: null,
  ha: null,
  haw: null,
  is: null,
  jw: null,
  kk: null,
  km: null,
  la: null,
  lv: null,
  ln: null,
  lt: null,
  lb: null,
  mg: null,
  mt: null,
  mi: null,
  mn: null,
  ne: null,
  oc: null,
  ps: null,
  fa: null,
  sa: null,
  sn: null,
  sd: null,
  si: null,
  sl: null,
  so: null,
  su: null,
  sw: null,
  tg: null,
  tt: null,
  tk: null,
  uz: null,
  cy: null,
  yi: null,
  yo: null,
  my: null,
  lo: null,
  nn: null,
  bo: null,
  ast: null,
  ceb: null,
  ff: null,
  ga: null,
  ig: null,
  kea: null,
  ku: null,
  ky: null,
  lg: null,
  luo: null,
  nso: null,
  ny: null,
  or: null,
  umb: null,
  wo: null,
  xh: null,
  zu: null,
};
